<div class="d-flex flex-column new-input-fields" style="height: calc(100vh - 125px)">
  <div class="d-flex justify-content-between mb-5">
    <div class="" style="width: 35%"></div>
    <div class="d-flex justify-content-between create-strategy-sec-bar" style="width: 30%">
      <div class="pointer create-strategy-sec" *ngIf="!secReview.vendorInfo" [ngClass]="{'is-active': currentSection == 'vendorInfo'}" (click)="moveToSection('vendorInfo')">
        <div class="sec-name">Vendor Details</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.vendorInfo" (click)="moveToSection('vendorInfo')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Vendor Details</div>
      </div>
      <div class="section-bar" [ngClass]="{'is-active-bar': currentSection == 'vendorInfo', 'section-bar-success': secReview.vendorInfo}"></div>
      <div class="pointer create-strategy-sec" *ngIf="!secReview.uploadResources" [ngClass]="{'is-active': currentSection == 'uploadResources'}" (click)="moveToSection('uploadResources')">
        <div class="sec-name">Strategy Offers and Details</div>
      </div>
      <div class="pointer reviewed-success" *ngIf="secReview.uploadResources" (click)="moveToSection('uploadResources')">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="sec-name">Strategy Offers and Details</div>
      </div>
    </div>
    <div class="" style="width: 35%"></div>
  </div>

  <div class="d-flex flex-fill min-h-0 overflow-auto">
    <div class="medium-12 columns" *ngIf="currentSection == 'vendorInfo'">
      <div class="row">
        <div class="medium-12 columns mb-2">
          <label style="font-weight: 600;color: #333333;">Personal Details</label>
        </div>
      </div>
      <div class="row tax-planning-client">
        <div class="medium-6 columns">
          <label>
            First Name*
            <input type="text" [(ngModel)]="vendor.contactFirstName" placeholder="First Name"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Last Name*
            <input type="text" [(ngModel)]="vendor.contactLastName" placeholder="Last Name"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Email
            <input type="text" [(ngModel)]="vendor.contactEmail" placeholder="Email"/>
            <div class="error" *ngIf="vendor.contactEmail && !vendor.contactEmail.match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')">Please check email format</div>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Phone Number
            <input type="text" input-mask [(ngModel)]="vendor.contactPhoneNumber" placeholder="Phone number"/>
            <!--            <div class="error" *ngIf="vendor.contactPhoneNumber && !vendor.contactPhoneNumber.match('^[0-9]{10}$')">Phone number should have 10 digits only</div>-->
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns mb-2">
          <label style="font-weight: 600;color: #333333;">Business Details</label>
        </div>
      </div>
      <div class="row tax-planning-client">
        <div class="medium-6 columns">
          <label>
            Business Name*
            <input type="text" [(ngModel)]="vendor.name" placeholder="Business Name"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Phone Number
            <input type="text" input-mask [(ngModel)]="vendor.phoneNumber" placeholder="Phone number"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Contact Us
            <input type="text" [(ngModel)]="vendor.website" placeholder="Website"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Active Vendor
            <div class="mt-2">
              <input class="pointer" type="radio" name="vendor_status" (click)="setVendorStatus('yes')" [checked]="vendor.active"> Yes
              <input class="pointer" type="radio" style="margin-left: 15px;" name="vendor_status" (click)="setVendorStatus('no')" [checked]="!vendor.active"> No
            </div>
          </label>
        </div>
        <div class="medium-12 columns">
          <label *ngIf="displayStrategies">
            Applicable Strategies
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="allTaxStrategies" [setPlaceHolder]="'Strategies'" [setSearchKey]="'name'" [setValueKey]="'id'" [setDefaultValue]=""
                                   (onValueSelect)="onStrategySelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-12 columns">
          <div class="d-flex flex-wrap">
            <div class="d-flex vendor-strategy mt-2 mb-2" *ngFor="let strategy of selectedStrategies;let i = index">
              <div class="strategy-name">{{strategy.strategyName || ''}}</div>
              <div class="pointer" style="margin-left: 5px;" (click)="removeSelectedStrategy(i)">
                <i class="icon ion-close-round"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="medium-12 columns mt-3">
          <label>Description
            <div style="border:1px solid #D0D5DD;border-radius: 3px;padding:10px;" [froalaEditor]="editorOptions" [(froalaModel)]="vendor.description"></div>
          </label>
        </div>
        <div class="medium-12 columns mt-3">
          <label>
            Logo
            <div style="font-size: 15px; text-align: left;">
              <div>Please upload your firm logo in PNG/SVG/JPEG format not exceeding 2000X900 pixels.</div>
            </div>
            <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
              <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
                <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="vendorLogoUpload" class="button upload-section-content">Upload Logo</label>
                  </span>
                  <input type="file" accept="image/*" id="vendorLogoUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader"/>
                </div>
              </div>
            </section>
          </label>
        </div>
        <div class="medium-12 columns mt-3" *ngIf="logoFiles.length > 0">
          <div class="d-flex flex-wrap">
            <div class="d-flex vendor-file-box mb-2 flex-column" *ngFor="let logo of logoFiles; let index = index;">
              <ng-template [ngIf]="logo.name">
                <div class="d-flex justify-content-between file-name-box">
                  <div class="file-name">{{logo.name}}</div>
                  <div class="pointer" (click)="deleteDocumentFile(logo, index)">
                    <i class="icon ion-android-close"></i>
                  </div>
                </div>
                <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
                  <img class="image-zoom" [src]="logo.link"/>
                </div>
              </ng-template>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="d-flex flex-column h-100 medium-12 columns" *ngIf="currentSection == 'uploadResources'">
      <app-vendor-strategies [strategies]="selectedStrategies" [vendorIdForCreate]="vendorIdForCreate"></app-vendor-strategies>
    </div>
  </div>
  <div class="mt-4 flex-shrink-0">
    <div class="medium-12" *ngIf="currentSection == 'vendorInfo'">
      <button class="button small float-right" (click)="goToNextSection('uploadResources')">Next</button>
      <button class="button small float-right cancel-button" (click)="closeCreatePopup()">Cancel</button>
    </div>
    <div class="medium-12" *ngIf="currentSection == 'uploadResources'">
      <button class="button small float-right" (click)="createOrEditVendor()">{{(editMode ? 'Update' : 'Create')}}</button>
      <button class="button small float-right cancel-button" (click)="goToPreviousSection('vendorInfo')">Back</button>
    </div>
  </div>
</div>

